import './Mini_Loader.css';

const Mini_Loader = () => <div className="Mini_Loader_Container"><div className="Mini_Loader"></div></div>

export default Mini_Loader